<div flexLayout="column" flexLayoutAlign="start stretch">
  <ng-container
    [ngTemplateOutlet]="template"
    [ngTemplateOutletContext]="{
      selectedTag: selectedTag$ | async,
      selectedTagType: selectedTagType$ | async,
      dataSource: (dataSource$ | async) || [],
      serviceCostOverrides: (serviceCostOverrides$ | async) || []
    }"
  >
  </ng-container>
</div>

<ng-template
  #template
  let-selectedTag="selectedTag"
  let-selectedTagType="selectedTagType"
  let-dataSource="dataSource"
  let-serviceCostOverrides="serviceCostOverrides"
>
  <div flexLayout="row" flexLayoutAlign="space-between center">
    <h3>Service Cost Pricing Plans</h3>
    <button type="button" mat-raised-button color="primary" (click)="addPlan()">
      Add Pricing Plan
    </button>
  </div>

  <div flex flexLayout="column" flexLayoutAlign="start stretch">
    @for (overridePlan of serviceCostOverrides; track overridePlan.id || overridePlan.planName) {
      <div flexLayout="column" flexLayoutAlign="start stretch" class="override">
        <div flexLayout="row" flexLayoutAlign="space-between center" class="header">
          <div flexLayout="row" flexLayoutAlign="start center">
            <h3>{{ overridePlan.planName }}</h3>
            <button
              type="button"
              mat-icon-button
              color="primary"
              matTooltip="Edit Plan Name"
              (click)="updatePlanName(overridePlan)"
            >
              <mat-icon>edit</mat-icon>
            </button>
          </div>
          <div flexLayout="row" flexLayoutAlign="end center" flexLayoutGap="1rem">
            <mat-checkbox
              [checked]="overridePlan.isDefault"
              labelPosition="before"
              matTooltip="Used when no specialty specified or it's not found"
              (change)="changeDefaultPlan(overridePlan)"
            >
              Default
            </mat-checkbox>
            @if (feeBasedServicesEnabled$ | async) {
              <button
                type="button"
                mat-icon-button
                color="primary"
                matTooltip="Add Service Fee"
                (click)="addServiceFee(overridePlan)"
              >
                <mat-icon>add service</mat-icon>
              </button>
            }
            <button
              type="button"
              mat-icon-button
              color="warn"
              matTooltip="Delete Cost Plan and all related fees."
              (click)="deletePlan(overridePlan, selectedTag)"
            >
              <mat-icon>delete_forever</mat-icon>
            </button>
          </div>
        </div>
        <div flexLayout="column" flexLayoutAlign="start stretch" class="body">
          <table flex mat-table [dataSource]="overridePlan.serviceCosts">
            <ng-container matColumnDef="serviceFriendlyId">
              <th mat-header-cell *matHeaderCellDef>Service Type</th>
              <td mat-cell *matCellDef="let service">
                @if (feeBasedServiceLookup$(service.friendlyId) | async; as feeBasedService) {
                  {{ feeBasedService?.displayName }}
                } @else {
                  <mat-spinner [diameter]="14"></mat-spinner>
                }
              </td>
            </ng-container>

            <ng-container matColumnDef="serviceActive">
              <th mat-header-cell *matHeaderCellDef>Active</th>
              <td mat-cell *matCellDef="let service">
                @if (service.active) {
                  <mat-icon color="accent" title="Active">toggle_on</mat-icon>
                } @else {
                  <mat-icon matTooltip="Inactive">toggle_off</mat-icon>
                }
              </td>
            </ng-container>

            <ng-container matColumnDef="serviceFee">
              <th mat-header-cell *matHeaderCellDef>Fee</th>
              <td mat-cell *matCellDef="let service">{{ service.fee | currency }}</td>
            </ng-container>

            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef>Actions</th>
              <td mat-cell *matCellDef="let serviceFee; let i = index">
                <button
                  type="button"
                  mat-icon-button
                  color="primary"
                  title="Edit Service Cost Fee"
                  (click)="editServiceFee(overridePlan, serviceFee)"
                >
                  <mat-icon>edit</mat-icon>
                </button>
                <button
                  type="button"
                  mat-icon-button
                  color="warn"
                  title="Delete Service Cost Fee"
                  (click)="deleteServiceFee(overridePlan, serviceFee, selectedTag)"
                >
                  <mat-icon>delete_forever</mat-icon>
                </button>
              </td>
            </ng-container>

            <tr
              mat-header-row
              *matHeaderRowDef="['serviceFriendlyId', 'serviceActive', 'serviceFee', 'actions']"
            ></tr>
            <tr
              mat-row
              *matRowDef="
                let service;
                columns: ['serviceFriendlyId', 'serviceActive', 'serviceFee', 'actions']
              "
            ></tr>
          </table>
        </div>

        <div flexLayout="row" flexLayoutAlign="start center" flexLayoutGap="1rem" class="footer">
          <span>Specialties</span>
          <mat-chip-list
            flex
            flexLayout="row"
            flexLayoutAlign="start center"
            #chipList
            aria-label="Specialties selection"
          >
            <div flex flexLayout="row wrap" flexLayoutAlign="start center">
              @for (specialty of overridePlan.specialties; track specialty.id || specialty) {
                <mat-chip flexLayout="row" flexLayoutAlign="start center">
                  <span>{{ specialty | tagDisplay: undefined : false | async }}</span>
                  <button
                    type="button"
                    matChipRemove
                    (click)="deleteSpecialty(overridePlan.planName, specialty)"
                  >
                    <mat-icon>cancel</mat-icon>
                  </button>
                </mat-chip>
              }
            </div>
          </mat-chip-list>
          <div flexLayout="row" flexLayoutAlign="end center">
            <button
              type="button"
              mat-icon-button
              color="primary"
              matTooltip="Add Specialty"
              (click)="addSpecialty(overridePlan.planName)"
            >
              <mat-icon>add</mat-icon>
            </button>
          </div>
        </div>
      </div>
    }
  </div>

  <table mat-table flex [dataSource]="dataSource">
    <ng-container matColumnDef="opinion-type">
      <td mat-cell *matCellDef="let overridePlan">
        <table flex mat-table [dataSource]="subTable$(overridePlan.serviceCosts)">
          <ng-container matColumnDef="default">
            <th mat-header-cell *matHeaderCellDef class="checkB" [attr.colspan]="4">
              <input
                type="checkbox"
                id="defaultChk"
                name="defaultChkName"
                matTooltip="Used when no specialty specified or it's not found"
                [checked]="overridePlan.isDefault"
                (change)="changeDefaultPlan(overridePlan)"
              />
              <label for="defaultChk">Default</label>
            </th>
          </ng-container>

          <ng-container matColumnDef="serviceFriendlyId">
            <th mat-header-cell *matHeaderCellDef>Service Type</th>
            <td mat-cell *matCellDef="let serviceFee">
              @if (feeBasedServiceLookup$(serviceFee.friendlyId) | async; as feeBasedService) {
                {{ feeBasedService?.displayName }}
              } @else {
                <mat-spinner [diameter]="14"></mat-spinner>
              }
            </td>
          </ng-container>

          <ng-container matColumnDef="serviceActive">
            <th mat-header-cell *matHeaderCellDef>Active</th>
            <td mat-cell *matCellDef="let serviceFee">
              @if (serviceFee.active) {
                <mat-icon color="accent" matTooltip="Active">toggle_on</mat-icon>
              } @else {
                <mat-icon matTooltip="Inactive">toggle_off</mat-icon>
              }
            </td>
          </ng-container>

          <ng-container matColumnDef="serviceFee">
            <th mat-header-cell *matHeaderCellDef>Fee</th>
            <td mat-cell *matCellDef="let serviceFee">{{ serviceFee.fee | currency }}</td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>Actions</th>
            <td mat-cell *matCellDef="let serviceFee; let i = index">
              <button
                type="button"
                mat-icon-button
                color="primary"
                matTooltip="Edit Service Cost Fee"
              >
                <mat-icon>edit</mat-icon>
              </button>
              <button
                type="button"
                mat-icon-button
                color="warn"
                matTooltip="Delete Service Cost Fee"
              >
                <mat-icon>delete_forever</mat-icon>
              </button>
            </td>
          </ng-container>

          <ng-container matColumnDef="header-opinion-display">
            <th mat-header-cell *matHeaderCellDef [attr.colspan]="3" class="notBorder">
              {{ overridePlan.planName }}
              <button type="button" mat-icon-button color="primary" matTooltip="Edit Plan Name">
                <mat-icon>edit</mat-icon>
              </button>
            </th>
          </ng-container>

          <ng-container matColumnDef="header-opinion-actions">
            <th mat-header-cell *matHeaderCellDef [attr.colspan]="1" class="notBorder">
              @if (feeBasedServicesEnabled$ | async) {
                <button type="button" mat-icon-button color="primary" matTooltip="Add Service Fee">
                  <mat-icon>add service</mat-icon>
                </button>
              }
              <button
                type="button"
                mat-icon-button
                color="warn"
                matTooltip="Delete Cost Plan and all related fees."
              >
                <mat-icon>delete_forever</mat-icon>
              </button>
            </th>
          </ng-container>

          <ng-container matColumnDef="specialties">
            <td mat-footer-cell *matFooterCellDef="" class="specialties" [attr.colspan]="4">
              <mat-toolbar>
                <span>Specialties</span>
                <span mat-spacer></span>
                <button type="button" mat-raised-button color="primary">Add Specialty</button>
              </mat-toolbar>

              <mat-form-field appearance="fill"> </mat-form-field>
            </td>
          </ng-container>

          <tr
            mat-header-row
            *matHeaderRowDef="['header-opinion-display', 'header-opinion-actions']"
          ></tr>
          <tr mat-header-row *matHeaderRowDef="['default']"></tr>
          <tr
            mat-header-row
            *matHeaderRowDef="['serviceFriendlyId', 'serviceActive', 'serviceFee', 'actions']"
          ></tr>
          <tr
            mat-row
            *matRowDef="
              let service;
              columns: ['serviceFriendlyId', 'serviceActive', 'serviceFee', 'actions']
            "
          ></tr>
          <tr mat-footer-row *matFooterRowDef="['specialties']"></tr>
        </table>
      </td>
    </ng-container>
    <tr mat-row *matRowDef="let row; columns: ['opinion-type']"></tr>
  </table>
</ng-template>
